// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Observable } from 'rxjs';

// export type ChatRole = 'user' | 'assistant';

// export interface ChatTurn {
//   role: ChatRole;
//   content: string;
// }

// export interface ConciergeResponse {
//   text?: string;   // backend antiguo
//   reply?: string;  // backend nuevo
// }

// @Injectable({ providedIn: 'root' })
// export class ConciergeService {
//   constructor(private http: HttpClient) {}

//   send(message: string, conversation: ChatTurn[]): Observable<ConciergeResponse> {
//     return this.http.post<ConciergeResponse>('/api/concierge/message', {
//       message,
//       conversation
//     });
//   }
// }
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type ConciergeResponse = { text?: string; reply?: string; chips?: string[] };

@Injectable({ providedIn: 'root' })
export class ConciergeService {
  constructor(private http: HttpClient) {}

  send(message: string, conversation: { role: 'user'|'assistant'; content: string }[]): Observable<ConciergeResponse> {
    return this.http.post<ConciergeResponse>('/api/concierge/message', {
      message,
      conversation,
    });
  }
}
